import { createFileRoute } from "@tanstack/react-router";
import { CreateStoreWizard } from "@/features/business/components/CreateStoreWizard";

export const Route = createFileRoute("/(onboarding)/store/create")({
  component: RouteComponent,
});

function RouteComponent() {
  return <CreateStoreWizard />;
}
